const translateErrorMessage = (err, defaultMessage = "Ocorreu um erro inesperado.", errorMappings = {}) => {
  const responseData = err?.response?.data;
  const message = Array.isArray(responseData) ? responseData[0] : responseData;

  if (!message || typeof message !== "string") return defaultMessage;

  return errorMappings[message] || message;
};

export default translateErrorMessage;
